export default {"src":"/trader-new/_next/static/media/offer.8878d34a.svg","height":620,"width":636,"blurWidth":0,"blurHeight":0};